/* Design templates available in the Print.App account, grouped by product.
   Store designs were imported from Print.App's curated store; "house" designs are ours. */
const TEMPLATES = {
  'business-cards-1': [
    ['design_01M3WYT1CV043ZEX0TBQJF4B5N','8fec603a-e69d-4e5c-8d91-ebe04427686f','Ink Edge'],
    ['design_01M3WYKYMHMCNZFGK0VSQQGCYQ','694f12e2-c250-4712-a4f8-b66fbf48f7fa','Flatlay'],
    ['design_01M3WYKYQQBN0KKC8HAFAV9QBR','0ffda5b7-f52d-4392-84c1-41a0c4d74ae7','Mosaic'],
    ['design_01M3WYKYQ53WH3ETAT0RR7SPA3','97b1e7b1-8968-4984-a84c-4609a1eeea43','Plain Blue'],
    ['design_01M3WYKYMYF19ER9C287Y3GTF6','3a9afb30-f1a4-4300-9dde-34a733ebd228','Plain Light'],
    ['design_01M3WYKYPRD3P6VR6P7QG6MV4C','8fd9855f-0927-4095-8fbe-ac763115d585','Organic'],
    ['design_01M3WYKYPA4EAKT01WPN3GC5ZY','aa46c960-f5ef-49ab-aae4-c2fc0c80f810','Organic Dark'],
    ['design_01M3WYKYNSRJACXJ4FPZJZW3F4','93017990-e33e-45a3-8fd6-b5d5f7681879','Floral Portrait'],
    ['design_01M3WYKYNCWC8EJ4GV1PXRPQDF','35aba893-5381-4952-a676-be8f3d93672a','Floral'],
  ],
  'wedding-announcements': [
    ['design_01M3WYKYCXPBQWDJSQCDK591QT','a1f21065-4273-482c-8875-6a3074897404','Luxury'],
    ['design_01M3WYKYE0Z0H9QZ8Y6N5RMQY1','c59d6ae9-d4a8-4a1a-b180-75a3cbc505f5','Navy Gold'],
    ['design_01M3WYKYDCC4S64BDC946S7E94','08025577-773e-415e-aad1-21151a334be3','Golden Gradient'],
    ['design_01M3WYKYGPHQVG6N7BAYNZDTAX','7341f799-581c-4fd2-a143-990f22381edf','Elegant'],
    ['design_01M3WYKYG2YK49XSR09NGQBPT6','a10f2d82-f108-4e06-ac76-1b8812d24b3c','Gold Lace'],
    ['design_01M3WYKYET0KVAYCAF2WRGQVE1','69586af0-266a-4cdc-989f-bf70f8f23633','Engagement'],
    ['design_01M3WYKYFEQV2H4KX6DMP7PFKB','d8bd735c-cd4b-4750-a18b-473a2908c918','Maroon'],
    ['design_01M3WYKYJCXN6C18KAMG2RTV3V','b8e23b6e-cba5-438f-afa5-6dfffb4fb8ae','Blooming Gold'],
    ['design_01M3WYKYHR2WXN6WRB39JZFEEZ','7dc1ca3f-e7b4-4c78-bad7-05fd85476a49','Cherry Blossom'],
    ['design_01M3WYKYK53MQAZT2NT93XPY49','c952ef10-0948-4a3d-9b4c-fb341d84f830','Bethany'],
    ['design_01M3WYKYM4GAMC6MK7GKW607DT','8010d8bc-988a-4d69-9c1d-c195b91a51d6','Floral'],
    ['design_01M3WYKYKRY3WEMY4BWR34BKYD','e7ea1986-233a-43f1-8dc5-0d24a90c40a2','Floral Burgundy'],
  ],
  'stickers-and-labels': [
    ['design_01M3WYKYCEZ3HA9222W045QHYP','8a5123d8-a917-4b9a-9ee4-c06d3bd03f97','Round Sticker'],
    ['design_01M3WYKY5PW2TE5G7QMRNEK767','48acfd8a-22c6-410d-9aaa-a35c67ab0b09','Circular Tag'],
  ],
  'posters': [
    ['design_01M3WYKYAZMC1PGQZ0V6WHB4GS','21bd1ddc-e8b9-4477-8a8d-ff320e2579ea22','Event Poster'],
    ['design_01M3WYKYBYCY072ZJJECNDB2QH','08adf7f4-d5dc-4a56-85a4-3bc14cab7e45','Race Day'],
  ],
  'brochures-and-flyers': [
    ['design_01M3WYKY7W6DQNPQ69DKYABAYP','e0d62ceb-f44c-4c36-bfe5-038b35a5650a','Awesome Event'],
    ['design_01M3WYKYBGT4GF99CTFA9B6VWT','b4ebe3f3-eb5b-4ec5-9ae8-73234a5a095b','Sale'],
  ],
  'photo-calendar': [
    ['design_01M3WYKY8JE8043T1GWAMQC0Y7','9a821e22-c470-4486-b12a-0253474e01e1','Office'],
    ['design_01M3WYKY9V212VBCBFR0CRZTFX','a95bc890-a651-4e20-91c7-f22ed2a03384','Polygon'],
  ],
  'vinyl-banners': [
    ['design_01M3WYV0WH28WS7M0MDGXDWYGW','e52b5036-6a95-45b8-968f-047bbaf685b9','Grand Opening'],
  ],
  'yard-sign': [
    ['design_01M3WYW16D4X1PYM3G0B8J42NG','3f68fdc7-2dc4-47bf-a0e4-1ee69b8f2572','For Sale'],
  ],
  'holiday-cards': [
    ['design_01M3WYX9MNYYWRKEP1BJC79JXN','e2d8b3a2-4996-4b06-98f2-50a5f77650fc','Evergreen'],
  ],
  'graduation-announcements': [
    ['design_01M3WYY7ZHN1A0Q70TBR4PW6WT','6065244e-e117-410b-b835-93c660885252','Class Of'],
  ],
};
